<template>
    <div class="efectivo__component">
        <h5><i class="fa fa-dollar"></i> Efectivo</h5>
        <div class="form-group">
            <div class="input-group">
                <label for="id">Monto</label>
                <input placeholder="$ 0" autocomplete="off" id="id" v-model="efectivo.monto" type="text" @input="input">
                <i class="bar"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import InputComp from "../../Componentes_Globales/Input/inputComp";
    import separadorMiles from "../../../util/separadorMiles";

    export default {
        name: "efectivo",
        data(){
            return {
                efectivo: {
                    monto: 0
                },
            }
        },
        methods: {
            input() {
                this.$emit('efectivo', this.efectivo)
            },


        }
    }
</script>

<style scoped>
    h5 {
        margin-right: 20px;
        font-weight: bold;
        font-size: 25px;
        margin-bottom: 15px;
        color: #4ab2e3;
    }
</style>
